import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import * as api from '../../api';

export function* getDefaultCoursesForCountry({ accessCode, productId }) {
    const payload = yield call(api.getDefaultCoursesForCountry, { accessCode, productId });
    if (payload.status === 200) {
        yield put(actions.getDefaultCoursesForCountrySuccess(payload.data));
    } else {
        yield put(actions.getDefaultCoursesForCountryFailure());
    }
}

export function* getDefaulCoursesForCountrySaga() {
    yield takeLatest(actions.GET_DEFAULT_COURSES_FOR_COUNTRY_REQUEST, getDefaultCoursesForCountry);
}

export function* getCoursesForCountry({ countryCode, productId }) {
    const payload = yield call(api.getCoursesForCountry, { countryCode, productId });
    if (payload.status === 200) {
        yield put(actions.getCoursesForCountrySuccess(payload.data));
    } else {
        yield put(actions.getCoursesForCountryFailure());
    }
}

export function* getCoursesForCountrySaga() {
    yield takeLatest(actions.GET_COURSES_FOR_COUNTRY_REQUEST, getCoursesForCountry);
}

export function* saveDefaultCoursesForCountry({ accessCode, productId, defaultCourses }) {
    const payload = yield call(api.saveDefaultCoursesForCountry, accessCode, productId, defaultCourses);
    if (payload.status === 200) {
        yield put(actions.saveDefaultCoursesForCountrySuccess());
    } else {
        yield put(actions.saveDefaultCoursesForCountryFailure());
    }
}

export function* saveDefaultCoursesForCountrySaga() {
    yield takeLatest(actions.SAVE_DEFAULT_COURSES_FOR_COUNTRY_REQUEST, saveDefaultCoursesForCountry);
}

export function* getCourses({ accessStatus, countryCode, stateCode, productId }) {
    const payload = yield call(api.getCourses, { accessStatus, countryCode, stateCode, productId });
    if (payload.status === 200) {
        yield put(actions.getCoursesSuccess(payload.data));
    } else {
        yield put(actions.getCoursesFailure());
    }
}

export function* getCoursesSaga() {
    yield takeLatest(actions.GET_COURSES_REQUEST, getCourses);
}

export function* saveDefaultCourses({ accessStatus, countryCode, stateCode, productId, defaultCourses }) {
    const payload = yield call(api.saveDefaultCourses, { accessStatus, countryCode, stateCode, productId, defaultCourses });
    if (payload.status === 200) {
        yield put(actions.saveDefaultCoursesSuccess(defaultCourses));
    } else {
        yield put(actions.saveDefaultCoursesFailure());
    }
}

export function* saveDefaultCoursesSaga() {
    yield takeLatest(actions.SAVE_DEFAULT_COURSES_REQUEST, saveDefaultCourses);
}



// WEBPACK FOOTER //
// ./app/containers/set-default-courses/saga.js